// src/models/vendas/NotaPag.js
import FormaPag, { MeioPagamento } from "../financeiro/FormaPag.js";
import { fromMoneyCents, normalizeMoney, toMoneyCents } from '../../utils/numberUtils';

export class NotaPag {
  static mesmoPagamento(pagamento, referencia) {
    if (!pagamento || !referencia) return false;
    return pagamento.id && referencia.id
      ? Number(pagamento.id) === Number(referencia.id)
      : Number(pagamento.item) === Number(referencia.item);
  }

  static saldoCentavos(total, pagamentos = [], selecionado = null) {
    return Math.max(0, toMoneyCents(total) - pagamentos
      .filter(pagamento => !NotaPag.mesmoPagamento(pagamento, selecionado))
      .reduce((soma, pagamento) => soma + toMoneyCents(pagamento.vPag), 0));
  }

  static proximoItem(pagamentos = []) {
    return Math.max(0, ...pagamentos.map(pagamento => Number(pagamento.item) || 0)) + 1;
  }

  static condicoesValidas(pagamento) {
    if (pagamento?.formaPag?.avista === true) return true;
    const quantidade = Number(pagamento?.qtdeParcela);
    const vencimento = String(pagamento?.dataVencimento || '').substring(0, 10);
    if (!Number.isInteger(quantidade) || quantidade <= 0 || !/^\d{4}-\d{2}-\d{2}$/.test(vencimento)) return false;
    const data = new Date(`${vencimento}T12:00:00Z`);
    return !Number.isNaN(data.getTime()) && data.toISOString().substring(0, 10) === vencimento;
  }

  static calcularRecebimento({ pagamento, formaPag = pagamento?.formaPag, recebido, total, pagamentos }) {
    const centavosRecebidos = toMoneyCents(recebido);
    if (centavosRecebidos < 0) throw new Error('O valor recebido não pode ser negativo.');
    const saldo = NotaPag.saldoCentavos(total, pagamentos, pagamento);
    const dinheiro = Number(formaPag?.meioPag) === MeioPagamento.Dinheiro;
    if (!dinheiro && centavosRecebidos > saldo) {
      throw new Error('Somente pagamentos em dinheiro podem gerar troco.');
    }
    const valorPagamento = Math.min(centavosRecebidos, saldo);
    return {
      ...pagamento,
      formaPagId: formaPag?.id,
      formaPag,
      vPag: fromMoneyCents(valorPagamento),
      vRec: fromMoneyCents(centavosRecebidos),
      vTroco: dinheiro ? fromMoneyCents(centavosRecebidos - valorPagamento) : 0,
      pago: dinheiro && valorPagamento > 0
    };
  }

  static reidratar(pagamento, formasPag = [], anterior = {}) {
    const formaPagId = pagamento?.formaPagId ?? anterior.formaPagId;
    return {
      ...anterior,
      ...pagamento,
      formaPagId,
      formaPag: formasPag.find(forma => Number(forma.id) === Number(formaPagId))
        || pagamento?.formaPag || anterior.formaPag,
      qtdeParcela: pagamento?.qtdeParcela ?? anterior.qtdeParcela ?? null,
      dataVencimento: pagamento?.dataVencimento ?? anterior.dataVencimento ?? null,
      vPag: normalizeMoney(pagamento?.vPag ?? anterior.vPag),
      vRec: normalizeMoney(pagamento?.vRec ?? anterior.vRec),
      vTroco: normalizeMoney(pagamento?.vTroco ?? anterior.vTroco)
    };
  }

  constructor() {
    this.id = 0;
    this.item = 1;
    this.notaId = 0;
    this.formaPagId = 0;
    this.formaPag = new FormaPag();
    this.vPag = 0;
    this.vRec = 0;
    this.vTroco = 0;
    this.qtdeParcela = null;
    this.dataVencimento = null;
    this.tefAutorizacao = '';
    this.tefBandeira = '';
    this.tefDataHora = '';
    this.cnpjCreden = '';
    this.terminalId = 0;
    this.configTEFid = null;
    this.tefSerieTerminal = '';
    this.tefComprovante = '';
    this.pago = false;
    this.tefNaoIntegrado = false;
    this.statusTEF = null;
  }
}
